import React from "react";
import { Container } from './styles'
import { ErrorCard } from "ui";
import { useLocation } from "hooks";

const NotFound = () => {
  const { isCreators } = useLocation()

  return (
    <Container $isCreators={isCreators}>
      <ErrorCard
        description='No pudimos encontrar la página que estabas buscando.'
        code='W1001'
      />
    </Container>
  );
};

export default NotFound;
